import { AuthType } from "./enums/auth-type.enum";

export class Admin {
  type: AuthType | string;
  description: string;
  venues: string[];
  cities: string[];
  created_by: string;
  edited_by: string;
  full_access: boolean;
  constructor(data) {
    this.full_access = data["full_access"] ? data["full_access"] : false;
    this.type = data["type"];
    this.description = data["description"];
    this.venues = data["venues"];
    this.cities = data["cities"];
    this.created_by = data["created_by"];
    this.edited_by = data["edited_by"];
  }

  toJSON() {
    return {
      full_access: this.full_access,
      type: this.type,
      description: this.description ? this.description : "",
      venues: this.venues ? this.venues : [],
      cities: this.cities ? this.cities : [],
      created_by: this.created_by ? this.created_by : "Jack Richard (03/31/20)",
      edited_by: this.edited_by ? this.edited_by : ""
    };
  }
}
